import { dashboardReducer } from "./dashboard/dashboard.reducers";
import { DASHBOARD_STATE_NAME, DashboardState } from "./dashboard/dashboard.state";
import { searchBarReducer } from "./search-bar/search-bar.reducers";
import { SEARCH_STATE_NAME, SearchState } from "./search-bar/search-bar.state";
import { userPreferenceReducer } from "./user-preferences/user-preference.reducer";
import { USER_PREFERENCE_STATE, UserPreferenceState,  } from "./user-preferences/user-preference.state";

export interface AppState {
    [DASHBOARD_STATE_NAME]: DashboardState,
    [SEARCH_STATE_NAME]: SearchState,
    [USER_PREFERENCE_STATE]: UserPreferenceState
};

export const appReducer = {
    [DASHBOARD_STATE_NAME]: dashboardReducer,
    [SEARCH_STATE_NAME]: searchBarReducer,
    [USER_PREFERENCE_STATE]: userPreferenceReducer
};